import React from 'react';
import Button from 'mrf/view/Button';
import { Link } from 'react-router-dom';
import Flex from 'mrf/layout/Flex';

export default function NewCrudButton({
    match,
    label,
    relativePath,
    color = 'primary',
    width = 'max',
    marginTop = 0,
    align='end',
    ...props
}) {
    return (
        <Flex justify={align} className={`mt-${marginTop}`}>
            <Button
                className='shadow'
                color={color}
                width={width}
                component={Link}
                match={match}
                relativePath={relativePath ?? 'new'}
                {...props}
            >
                {label}
            </Button>
        </Flex>
    )
}
